module.exports = __webpack_public_path__ + "static/media/4.4c185ea0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/gifs/4.gif
// module id = 245
// module chunks = 0